import { render } from "./ProdOrder.vue?vue&type=template&id=1d24d210"
import script from "./ProdOrder.vue?vue&type=script&lang=js"
export * from "./ProdOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__